import type { ReactNode } from "react";
import { calcBothTabsHaveContent } from "@/panels/modules/panels/components/PanelsView.helpers";
import { usePanelsStore } from "@/panels/modules/panels/store/panels.store";
import type { MainPanelKey, TabOption } from "@/panels/modules/panels/store/panels.store.types";
import { MainPanelContent } from "./MainPanelContent";

interface CollapsiblePanelProps {
    panelId: MainPanelKey;
    tabASlot?: ReactNode;
    tabBSlot?: ReactNode;
}

export const MainPanel = ({ panelId, tabASlot, tabBSlot }: CollapsiblePanelProps) => {
    const store = usePanelsStore();
    const panelConfig = store[panelId];

    const bothTabsHaveContent = calcBothTabsHaveContent({
        tabASlot: tabASlot,
        isTabAClosed: panelConfig.a.isClosed,
        tabBSlot: tabBSlot,
        isTabBClosed: panelConfig.b.isClosed,
    });

    const onTabChange = (tab: TabOption) => {
        store.setSelectedTab(panelId)(tab);
    };

    const onCloseTab = (tab: TabOption) => {
        store.setIsClosed(panelId)(tab)(!panelConfig[tab].isClosed);
    };

    const onMinimizeTab = (tab: TabOption) => {
        store.setIsMinimized(panelId)(tab)(!panelConfig[tab].isMinimized);
    };

    return (
        <MainPanelContent
            mainPanelConfig={panelConfig}
            showTabBar={bothTabsHaveContent}
            onTabChange={onTabChange}
            onCloseTab={onCloseTab}
            onMinimizeTab={onMinimizeTab}
            tabASlot={tabASlot}
            tabBSlot={tabBSlot}
            showHeader={panelConfig[panelConfig.selectedTab].showHeader}
        />
    );
};
